import { useFirestore } from '@betwyll/btw-core-backoffice';
import React from 'react';

export default function withFirestore(Comp) {
  return props => {
    const firestore = useFirestore();
    return <Comp {...props} firestore={firestore} />;
  };
}
